import { getSelectedCustomer } from '@/app/slices/userSlice';
import { userIsIndividual } from '@/helpers/customerUtils';
import { State } from '@/types/State';
import { Alert } from '@mui/material';
import { useSelector } from 'react-redux';

import { useLocation } from 'react-router-dom';
import { Typography } from 'ui/mui';

const ConditionalAlert = () => {
  const selectedCustomer = useSelector((state: State) =>
    getSelectedCustomer(state),
  );

  const loggedInCustomer = useSelector(
    (state: State) => state.user?.customer?.name,
  );

  const isLinkedAccount =
    selectedCustomer?.isLinked && userIsIndividual(selectedCustomer);

  const location = useLocation();
  const isAvtalPage = location.pathname === '/avtal';
  const isPowerHubPage = location.pathname === '/bestall-power-hub';

  return (
    <>
      {isAvtalPage && isLinkedAccount && (
        <Alert severity='info' sx={{ borderRadius: 0 }}>
          <Typography variant='body2' sx={{ fontWeight: 600 }}>
            Du ({loggedInCustomer}) har tillgång till kontot men kan inte ändra
            avtal.
          </Typography>
        </Alert>
      )}
      {isPowerHubPage && isLinkedAccount && (
        <Alert severity='info' sx={{ borderRadius: 0 }}>
          <Typography variant='body2' sx={{ fontWeight: 600 }}>
            Du ({loggedInCustomer}) har tillgång till kontot men kan inte
            beställa en power hub.
          </Typography>
        </Alert>
      )}
    </>
  );
};

export default ConditionalAlert;
